
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContentText,
    DialogActions,
    DialogContent,
    Slide,
    Paper,
    FormControl,
    InputLabel,
    Select,
    Autocomplete,
    Tooltip,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import {useTheme} from '@mui/material/styles';
import {ListViewFilterModel,
        ListViewColumnModel,
        ViaElementFilterModel,
        RecordModel,
        FieldMetadataModel,
        ActionModel} from '../../models/models';
import {ListConfigurationModel,
        ListViewConfigurationModel} from '../../models/modelsListConfiguration';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {fetchFields, fetchViaElements, initListViewFilter} from "../../services/metadataApi";
import {DndContext,
        closestCenter,
        PointerSensor,
        useSensor,
        useSensors} from "@dnd-kit/core";
import type { Modifier } from "@dnd-kit/core";
import {SortableContext,
        useSortable,
        verticalListSortingStrategy } from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {ListFilterSaveComponent} from './ListFilterSave';

/*
DEFINE TYPES

*/

type FilterRow = {
  filter: ListViewFilterModel;
  fieldSearchText: string;
}

type FilterComparisonSettingType = 'eq' | 'neq' | 'geq' | 'leq' | 'gt' | 'lt' | 'cont' | 'ncont' | 'in' | 'nin';

const comparisonSettingOptions = [{value: 'eq', label: 'equal'},
                                  {value: 'neq', label: 'not equal'},
                                  {value: 'geq', label: 'greater than or equal'},
                                  {value: 'leq', label: 'less than or equal'},
                                  {value: 'gt', label: 'greater than'},
                                  {value: 'lt', label: 'less than'},
                                  {value: 'cont', label: 'contains'},
                                  {value: 'ncont', label: 'not contains'},
                                  {value: 'in', label: 'in list'},
                                  {value: 'nin', label: 'not in list'}]

/*
DEFINE DRAG BEHAVIOUR / STRATEGY
*/

const restrictToVerticalBounds: Modifier = ({
  transform,
  activeNodeRect,
  containerNodeRect
}) => {
  if (!transform || !activeNodeRect || !containerNodeRect) return transform;
  const initialTop = activeNodeRect.top-containerNodeRect.top;
  const minY = -initialTop;
  const maxY = containerNodeRect.height-activeNodeRect.height - initialTop;
  const clampedY = Math.min(Math.max(transform.y, minY), maxY);

  return { ...transform,
           x:0,
           y: clampedY
         }
}

/*
DEFINE CUSTOM AUTO COMPLETE FIELD
*/

export const AutoCompleteElement: React.FC<{
  fields: FieldMetadataModel[],
  selectedField: FieldMetadataModel,
  selectField: (value: FieldMetadataModel) => void
}> = ({
  fields,
  selectedField,
  selectField
}) => {
//  const filteredFields = fields.filter((thisField: FieldMetadataModel) => thisField.Label_sys.toLowerCase().includes(row.fieldSearchText.toLowerCase()));
  const [searchText, setSearchText] = useState<string>("");
  const filteredFields = fields.filter((thisField: FieldMetadataModel) => thisField.Label_sys.toLowerCase().includes(searchText.toLowerCase()));
  return (
          <Autocomplete
            disableClearable
            options={filteredFields}
            fullWidth
            getOptionLabel={(option) => {
              return option.Label_sys
            }}
            onInputChange={(_, value, reason) => {
              if(reason !== 'reset') {
//              setFieldSearchText(row, value)
              }
            }}
            onChange={(_, value) => {
//            setFieldSearchText(row, "")
              selectField(value)
            }}
            value={selectedField}

            renderOption={(props, option) => (
              <li
                {...props}
                key={`option-key-${option.Uuid_sys}`}
              >
                <Box>
                  <Typography>{option.Label_sys} </Typography>
                  <Typography color="textSecondary">{option.ApiName_sys}</Typography>
                </Box>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                required={true}
                size="small"
                label="Field Label"
                variant="filled"
                placeholder="Type field label"
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
              />
            )}
          />
        )

}

//  const autoCompleteElement = () => {



/*
DEFINE THE DRAGABLE ROW
(EACH FILTER NEEDS TO BE ONE ROW)
*/

const DragableRow = ({row,
                      fields,
                      onDelete,
                      setSelectedField,
                      addViaField,
                      setValue,
                      setComparisonSetting}:
                     {row: FilterRow,
                      fields: FieldMetadataModel[],
                      onDelete: (row: FilterRow) => void,
                      setSelectedField: (thisFilterRow: FilterRow, value: FieldMetadataModel) => void,
                      addViaField: (thisFilterRow: FilterRow, value: FieldMetadataModel, currentRank: number) => void,
                      setValue: (row: FilterRow, value: string) => void,
                      setComparisonSetting: (row: FilterRow, value: string) => void}) => {

     const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: row.filter.Uuid_sys});
     const {accessToken, onInvalidToken} = useAuth();

     const style = {
       transform: CSS.Transform.toString(transform),
       transition,
       opacity: isDragging ? 0.5 : 1,
     }

     const selectField = (thisField: FieldMetadataModel) => {
       setSelectedField(row, thisField)
     }

     const selectViaField = (thisField: FieldMetadataModel, rank: number) => {
       addViaField(row, thisField, rank)
     }


     const dynamicFieldElement = () => {
       return (
         <Typography
           variant="body1"
         >
           {row.filter.Value_sys.startsWith('$') ?
             <CheckBoxIcon/>
             :
             <CheckBoxOutlineBlankIcon/>
           }
         </Typography>
       )
     }

     const valueFieldElement = () => {
       return (
         <TextField
           disabled={false}
           multiline={false}
           rows={1}
           required={true}
           size="small"
           label={"Value"}
           variant="filled"
           value={row.filter.Value_sys}
           onChange={(e) => {setValue(row, e.target.value)}}
        />
      )
    }

    const rankFieldElement = () => {
      return (
        <Typography
          variant="body1"
        >
          {row.filter.Rank_sys}
        </Typography>
      )
    }

    const deleteFieldElement = () => {
      return(
        <IconButton
          edge="start"
          color="inherit"
          onClick={() => {onDelete(row)}}
          aria-label="close"
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      )
    }

    const comparisonSettingElement = () => {
      return(
        <FormControl
          fullWidth
          variant="filled"
        >
          <InputLabel required={true}>
            Operation
          </InputLabel>

          <Select
            value={row.filter.ComparisonSetting_sys}
            size="small"
            onChange={(e)=>{setComparisonSetting(row, e.target.value)}}
          >
            {comparisonSettingOptions.map((thisOption) => {
              return (
                <MenuItem key={thisOption.value} value={thisOption.value}>{thisOption.label}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      )
    }


  const viaElement = (thisViaField: ViaElementFilterModel) => {

    const selectThisViaField = (thisField: FieldMetadataModel) => {
      selectViaField(thisField, thisViaField.rank)
    }

    return (
      <Box
        key={`${thisViaField.selectedField.ApiName_sys}-${thisViaField.rank}`}
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <SubdirectoryArrowRightIcon fontSize='small'/>

        <AutoCompleteElement
          fields={thisViaField.availableFields}
          selectedField={thisViaField.selectedField}
          selectField={selectThisViaField}
        />

      </Box>
    )
  }

  const viaElements = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          ml: 4,
          mt: 1,
          gap: 1
        }}
      >

        {
          row.filter.viaElements.map((thisViaField: ViaElementFilterModel) => viaElement(thisViaField))
        }

      </Box>
    )
  }

    const selectFieldElement = () => {
      return(
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minWidth: "16rem"
          }}
        >
         <AutoCompleteElement
           fields = {fields}
           selectedField = {row.filter.ReferencedField_sys}
           selectField = {selectField}
         />
         {
           row.filter.ReferencedField_sys.Type_sys === 'ForeignKey' &&
           viaElements()
         }


        </Box>
      )
    }


    return (
      <TableRow ref={setNodeRef} style={style} {...attributes}>
        <TableCell>{selectFieldElement()}</TableCell>
        <TableCell>{comparisonSettingElement()}</TableCell>
        <TableCell>{valueFieldElement()}</TableCell>
        <TableCell>{dynamicFieldElement()}</TableCell>
        <TableCell>{rankFieldElement()}</TableCell>
        <TableCell>{deleteFieldElement()}</TableCell>

        <TableCell>
          <IconButton {...listeners} {...attributes}>
             <DragHandleIcon fontSize='small' />
          </IconButton>
        </TableCell>
      </TableRow>
    )
  }


type ListFilterComponentProps = {
  displayFilters: boolean,
  listConfig: ListConfigurationModel,
  onCloseDialog: () => void,
  onClearDialog: () => void,
  onApplyFilters: (filters: ListViewFilterModel[], filterLogic: string) => void,
  onSaveFilters?: (overwriteListView: boolean, listViewLabel: string, filters: ListViewFilterModel[], filterLogic: string) => void,
  context?: any
}
export const ListFilterComponent: React.FC<ListFilterComponentProps> = ({
  displayFilters,
  listConfig,
  onCloseDialog,
  onClearDialog,
  onApplyFilters,
  onSaveFilters,
  context={}
}) => {


  const initFilterRow = (thisFilter: ListViewFilterModel) => {
    return {filter: thisFilter,
            fieldSearchText: ''}
  }

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

//  const [mutableListView, setMutableListView] = useState<ListViewModel>(listView);
  const [mutableFilterRows, setMutableFilterRows] = useState<FilterRow[]>([])
  const [mutableFilterLogic, setMutableFilterLogic] = useState<string>("");
  const [availableFields, setAvailableFields] = useState<FieldMetadataModel[]>([]);
  const [displaySaveDialog, setDisplaySaveDialog] = useState<boolean>(false);

  useEffect(() => {
    setMutableFilterRows(listConfig.filters.map((thisFilter: ListViewFilterModel) => initFilterRow(thisFilter)))
    setMutableFilterLogic(listConfig.filterLogic)
  }, [listConfig]); // eslint-disable-line react-hooks/exhaustive-deps


  const sensors = useSensors(useSensor(PointerSensor));

  //issue: this search text is actually global (i.e., for all filters)

  useEffect(() => {
    const thisObjectName = context.objectApiName ?? getObjectName(objectName);
    if(thisObjectName){
      fetchFields(accessToken, thisObjectName)
        .then((fields) => {
          setAvailableFields(fields);
        })
        .catch((err) => {
          setErrorMessage(err.message)
        })
    }
  }, [objectName, context?.objectApiName]); // eslint-disable-line react-hooks/exhaustive-deps



  const setComparisonSetting = (thisFilterRow: FilterRow, value: string) => {
    setMutableFilterRows(previousRows => previousRows.map((row: FilterRow) => {
      if(row.filter.Uuid_sys === thisFilterRow.filter.Uuid_sys) {
        const newFilter = {...row.filter,
                           ComparisonSetting_sys: value as FilterComparisonSettingType}
        return {...row,
                filter: newFilter}
      }
      return row
    }))
  }
  const setValue = (thisFilterRow: FilterRow, value: string) => {
    setMutableFilterRows(previousRows => previousRows.map((row: FilterRow) => {
      if(row.filter.Uuid_sys === thisFilterRow.filter.Uuid_sys) {
        const newFilter = {...row.filter,
                           Value_sys: value}

        return {...row,
                filter: newFilter}
      }
      return row
    }))
  }





  const addViaField = async (thisFilterRow: FilterRow, value: FieldMetadataModel, currentRank: number)=> {
    //reset via elements
    //from an index currentRank on.
    //this means:
    //keep all via elements with rank <= currentRank
    //adapt via elements add currentRank to be selected field;
    //add new via elements with a higher rank

    const newViaElements: ViaElementFilterModel[] = [];
    if(value.Type_sys ==='ForeignKey'){
      const relatedObjectApiName = value.ReferencedObject_sys.ApiName_sys
      await fetchViaElements(accessToken, relatedObjectApiName)
        .then((viaElement) => {
          newViaElements.push(viaElement)
        })
        .catch((err) => {
          console.log('err', err)
        })
    }

    const updatedRows = mutableFilterRows.map((row: FilterRow) => {
      if(row.filter.Uuid_sys === thisFilterRow.filter.Uuid_sys) {
        //adapt via Elements (but don't overwrite referenced field)
//        const nnewViaElements = [...row.filter.viaElements]
        const nnewViaElements = row.filter.viaElements.filter((thisViaElement) => thisViaElement.rank <= currentRank);
        nnewViaElements[currentRank].selectedField = value;
        newViaElements.map((thisElement: ViaElementFilterModel, index) => {
          thisElement.rank = currentRank+index+1;
          nnewViaElements.push(thisElement);
        })
        const newFilter = {...row.filter,
                           viaElements: nnewViaElements}
        return {...row,
                filter: newFilter}
       }
       return row
     })

    setMutableFilterRows(updatedRows)

  }



  const setSelectedField = async (thisFilterRow: FilterRow, value: FieldMetadataModel)=> {

    //reset via elements
    const newViaElements: ViaElementFilterModel[] = [];
    if(value.Type_sys ==='ForeignKey'){
      const relatedObjectApiName = value.ReferencedObject_sys.ApiName_sys
      await fetchViaElements(accessToken, relatedObjectApiName)
        .then((viaElement) => {
          newViaElements.push(viaElement)
        })
        .catch((err) => {
          console.log('err', err)
        })
    }

    const updatedRows = mutableFilterRows.map((row: FilterRow) => {
      if(row.filter.Uuid_sys === thisFilterRow.filter.Uuid_sys) {
          const newFilter = {...row.filter,
                              ReferencedField_sys: value,
                              viaElements: newViaElements}
          return {...row,
                  filter: newFilter}
       }
       return row
     })


    setMutableFilterRows(updatedRows)

  }


  /*
  const setFieldSearchText = (thisFilterRow: FilterRow, value: string) => {
    setMutableFilterRows(previousRows => previousRows.map((row: FilterRow) => {
      if(row.filter.Uuid_sys === thisFilterRow.filter.Uuid_sys) {
        return {...row,
                fieldSearchText: value}
      }
      return row
    }))
  }
  */

  const addFilterRow = () => {

    initListViewFilter(accessToken, listConfig.listViewUuid)
        .then((thisFilter) => {
          const newRank = mutableFilterRows.length + 1
          thisFilter.Rank_sys = newRank
          const newFilterRow = initFilterRow(thisFilter);
          setMutableFilterRows(previousRows => [...previousRows, newFilterRow]);

        })
        .catch((err) => {
          console.log(err.message)
          setErrorMessage(err.message)
        })

  }


  const deleteFilterRow = (thisFilterRow: FilterRow) => {
    const currentRank = thisFilterRow.filter.Rank_sys;
    setMutableFilterRows(previousRows =>
         previousRows.filter((row: FilterRow) => {
                        if(row.filter.Uuid_sys !== thisFilterRow.filter.Uuid_sys) return true;
                        return false
                      })
                      .map((row: FilterRow) => {
                        if(row.filter.Rank_sys > currentRank){
                          const newFilter = {...row.filter,
                                             Rank_sys: row.filter.Rank_sys-1}
                          return {...row,
                                  filter: newFilter}
                        } else {
                          return row
                        }
                      }))
  }

  const handleDragEnd = (event: any) => {
    const {active, over} = event;
    if(!over || active.id === over.id) return;

    const activeRow = mutableFilterRows.find((thisRow) => thisRow.filter.Uuid_sys === active.id);
    const overRow = mutableFilterRows.find((thisRow) => thisRow.filter.Uuid_sys === over.id);
    if(!activeRow || !overRow) return;

    const isMovingDown = activeRow.filter.Rank_sys < overRow.filter.Rank_sys;

    setMutableFilterRows(previousRows => {

      const updatedRows = previousRows.map((thisRow: FilterRow) => {

      if(thisRow.filter.Uuid_sys === activeRow.filter.Uuid_sys){
        //repalce the rank
        const newRank = overRow.filter.Rank_sys;
        const newFilter = {
          ...thisRow.filter,
          Rank_sys: newRank
        }
        return {...thisRow,
                filter: newFilter}
      } else if(isMovingDown){
        if(thisRow.filter.Rank_sys > activeRow.filter.Rank_sys && thisRow.filter.Rank_sys <= overRow.filter.Rank_sys){
          //decrease the row rank
          const newRank = thisRow.filter.Rank_sys - 1
          const newFilter = {
            ...thisRow.filter,
            Rank_sys: newRank
          }
          return {...thisRow,
                  filter: newFilter}
        }
      } else {
        if(thisRow.filter.Rank_sys < activeRow.filter.Rank_sys && thisRow.filter.Rank_sys >= overRow.filter.Rank_sys){
          //increase the row rank
          const newRank = thisRow.filter.Rank_sys + 1
          const newFilter = {
            ...thisRow.filter,
            Rank_sys: newRank
          }
          return {...thisRow,
                  filter: newFilter}
        }
      }
      return thisRow
    }
  )
    return updatedRows.sort((filterRowA, filterRowB) => {
                             if(filterRowA.filter.Rank_sys > filterRowB.filter.Rank_sys) return 1
                                return -1
                      })
  }
)

  }

  const closeDialog = () => {
    onCloseDialog()
  }

  const clearDialog = () => {
    onClearDialog()
  }


  const applyFilters = () => {
    const filters = mutableFilterRows.map((thisRow: FilterRow) => thisRow.filter);
    onApplyFilters(filters, mutableFilterLogic);
  }

  const saveFilters = (overwriteList: boolean, listLabel: string) => {
    const filters = mutableFilterRows.map((thisRow: FilterRow) => thisRow.filter);
    if(onSaveFilters) onSaveFilters(overwriteList, listLabel, filters, mutableFilterLogic);

  }


  return (
    <Dialog
          open={displayFilters}
          onClose={() => closeDialog()}
          fullWidth
          maxWidth={'lg'}
//          fullScreen
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '70vh'
            }
          }}
    >

     <ListFilterSaveComponent
        displaySaveDialog={displaySaveDialog}
        listConfig={listConfig}
        onCloseDialog={() => {setDisplaySaveDialog(false)}}
        onSave={saveFilters}
      />

    <DialogTitle>
      <Toolbar sx={{justifyContent: 'space-between'}}>
         <Typography variant="h6">
            Customize Filters
         </Typography>

         <IconButton
            edge="start"
            color="inherit"
            onClick={() => closeDialog()}
            aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </DialogTitle>

    <Box sx={{height: '100%'}}>

      <DialogActions>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => applyFilters()}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }}
            >
              <Typography>
                Apply
              </Typography>
              <CheckIcon fontSize="small"/>
            </Box>
          </Button>

          {onSaveFilters &&

          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => setDisplaySaveDialog(true)}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }}
            >
              <Typography variant='body2'>
                Save
              </Typography>
              <SaveIcon fontSize="small"/>
            </Box>
          </Button>
        }

          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => clearDialog()}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }}
            >
              <Typography>
                Clear
              </Typography>
              <CloseIcon fontSize="small"/>
            </Box>
          </Button>


      </DialogActions>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%'
          }}
        >
          <TextField
            fullWidth
            disabled={false}
            multiline={false}
            rows={1}
            required={true}
            size="small"
            label={"Filter Logic (e.g., (1 OR 2) AND 3)"}
            variant="filled"
            value={mutableFilterLogic}
            onChange={(event) => {setMutableFilterLogic(event.target.value)}}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }}
        >

          <TableContainer component = {Paper}>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              modifiers={[restrictToVerticalBounds]}
              onDragEnd={handleDragEnd}

            >
              <SortableContext
                items={mutableFilterRows.map((thisRow) => thisRow.filter.Uuid_sys)}
                strategy={verticalListSortingStrategy}
              >
                <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontWeight: 600}}>Field</TableCell>
                  <TableCell sx={{fontWeight: 600}}>Operator</TableCell>
                  <TableCell sx={{fontWeight: 600}}>Value</TableCell>
                  <TableCell sx={{fontWeight: 600}}>Is Dynamic</TableCell>
                  <TableCell sx={{fontWeight: 600}}>Rank</TableCell>
                  <TableCell sx={{fontWeight: 600}}>Delete</TableCell>
                  <TableCell sx={{fontWeight: 600}}>Drag</TableCell>
                </TableRow>
              </TableHead>


                  <TableBody>
                    {mutableFilterRows.map((thisRow) => (
                      <DragableRow
                        key={thisRow.filter.Uuid_sys}
                        row={thisRow}
                        fields={availableFields}
                        onDelete={deleteFilterRow}
                        setValue={setValue}
                        setSelectedField={setSelectedField}
                        addViaField={addViaField}
                        setComparisonSetting={setComparisonSetting}
                      />
                    ))}

                  </TableBody>

                </Table>

              </SortableContext>


            </DndContext>


          </TableContainer>


          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mt: 2
            }}
          >
            <Button
              startIcon={<AddIcon fontSize="small"/>}
              color="primary"
              variant="contained"
              onClick={() => addFilterRow()}
            >
              Add Row
            </Button>
          </Box>


        </Box>

      </DialogContent>



    </Box>
    </Dialog>

  );

};
